import { isNullOrUndefined } from "@pineapplelab/util";
import { Core } from "../../core/core";
/**
 * If the value is null or undefined, none other decorator will be evaluated:
 *
 * isNullOrUndefined( value )
*/
export function IsOptional() {
    return function (target, propertyKey) {
        Core.setFieldValidator(target, propertyKey, {
            name: 'IsOptional',
            isValid: function (o, f) { return isNullOrUndefined(o[f]); },
            freePass: true
        });
    };
}
